module.exports = __webpack_public_path__ + "img/linkedin.86570c68.svg";